import { render } from "./AdvancedSection.vue?vue&type=template&id=f20e8088&scoped=true"
import script from "./AdvancedSection.vue?vue&type=script&lang=js"
export * from "./AdvancedSection.vue?vue&type=script&lang=js"

import "./AdvancedSection.vue?vue&type=style&index=0&id=f20e8088&lang=scss&scoped=true"

import exportComponent from "../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f20e8088"]])

export default __exports__